module.exports = __webpack_public_path__ + "static/media/ICA.54f7499c.svg";